import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';

import Icon from '../../../components/AppIcon';


const WhatsAppActionsModal = ({ isOpen, onClose }) => {
  const [selectedAction, setSelectedAction] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const actions = [
    {
      id: 'send-message',
      icon: 'Send',
      label: 'إرسال رسالة',
      description: 'إرسال رسالة واتساب مباشرة',
      color: '#25D366'
    },
    {
      id: 'ai-compose',
      icon: 'Sparkles',
      label: 'كتابة رسالة بالذكاء الاصطناعي',
      description: 'استخدام OpenAI لكتابة رسالة احترافية',
      color: '#10B981'
    },
    {
      id: 'broadcast',
      icon: 'Radio',
      label: 'بث جماعي',
      description: 'إرسال رسالة لمجموعة من العملاء',
      color: '#3B82F6'
    },
    {
      id: 'templates',
      icon: 'FileText',
      label: 'استخدام قالب',
      description: 'اختيار من القوالب الجاهزة',
      color: '#8B5CF6'
    },
    {
      id: 'smart-reply',
      icon: 'Zap',
      label: 'رد ذكي تلقائي',
      description: 'توليد ردود ذكية باستخدام OpenAI',
      color: '#F59E0B'
    },
    {
      id: 'schedule',
      icon: 'Clock',
      label: 'جدولة رسالة',
      description: 'جدولة إرسال رسالة في وقت محدد',
      color: '#EC4899'
    }
  ];

  const integrations = [
    {
      id: 'openai-integration',
      icon: 'Brain',
      label: 'تفعيل OpenAI',
      description: 'تحسين الرسائل تلقائياً',
      enabled: true
    },
    {
      id: 'auto-translate',
      icon: 'Languages',
      label: 'ترجمة تلقائية',
      description: 'ترجمة الرسائل للغات متعددة',
      enabled: false
    },
    {
      id: 'sentiment-analysis',
      icon: 'Heart',
      label: 'تحليل المشاعر',
      description: 'تحليل نبرة الرسائل الواردة',
      enabled: true
    }
  ];

  const handleActionClick = async (actionId) => {
    setSelectedAction(actionId);
    setIsProcessing(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 800));
      
      switch(actionId) {
        case 'ai-compose': alert('فتح محرر الرسائل بالذكاء الاصطناعي...');
          break;
        case 'smart-reply': alert('توليد ردود ذكية باستخدام OpenAI...');
          break;
        default:
          alert(`تنفيذ إجراء: ${actions?.find(a => a?.id === actionId)?.label}`);
      }
    } catch (error) {
      alert('حدث خطأ في تنفيذ الإجراء');
    } finally {
      setIsProcessing(false);
      setSelectedAction(null);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="إجراءات واتساب"
      size="lg"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-6" dir="rtl">
        {/* Actions Section */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
            <Icon name="Zap" size={20} color="#25D366" />
            الإجراءات المتاحة
          </h3>
          <div className="grid grid-cols-2 gap-3">
            {actions?.map((action) => (
              <button
                key={action?.id}
                onClick={() => handleActionClick(action?.id)}
                disabled={isProcessing && selectedAction === action?.id}
                className="p-4 bg-gray-800/50 hover:bg-gray-700/50 border border-gray-700 rounded-xl transition-all text-right group"
                style={{
                  borderColor: selectedAction === action?.id ? action?.color : undefined
                }}
              >
                <div className="flex items-start gap-3">
                  <div
                    className="p-2 rounded-lg"
                    style={{ backgroundColor: `${action?.color}20` }}
                  >
                    <Icon name={action?.icon} size={20} color={action?.color} />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white font-semibold text-sm mb-1">
                      {action?.label}
                    </h4>
                    <p className="text-gray-400 text-xs">
                      {action?.description}
                    </p>
                  </div>
                </div>
                {isProcessing && selectedAction === action?.id && (
                  <div className="mt-2 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-400 border-t-transparent"></div>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Integrations Section */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
            <Icon name="Plug" size={20} color="#3B82F6" />
            التكاملات والخيارات
          </h3>
          <div className="space-y-3">
            {integrations?.map((integration) => (
              <div
                key={integration?.id}
                className="p-4 bg-gray-800/50 border border-gray-700 rounded-xl flex items-center justify-between"
              >
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-blue-500/20 rounded-lg">
                    <Icon name={integration?.icon} size={18} color="#3B82F6" />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm">
                      {integration?.label}
                    </h4>
                    <p className="text-gray-400 text-xs">
                      {integration?.description}
                    </p>
                  </div>
                </div>
                <div
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    integration?.enabled
                      ? 'bg-green-500/20 text-green-400' :'bg-gray-700 text-gray-400'
                  }`}
                >
                  {integration?.enabled ? 'مفعّل' : 'معطّل'}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-3">
          <div className="p-3 bg-green-500/10 border border-green-500/30 rounded-lg text-center">
            <div className="text-2xl font-bold text-green-400">127</div>
            <div className="text-xs text-gray-400 mt-1">رسائل مرسلة</div>
          </div>
          <div className="p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg text-center">
            <div className="text-2xl font-bold text-blue-400">89%</div>
            <div className="text-xs text-gray-400 mt-1">معدل القراءة</div>
          </div>
          <div className="p-3 bg-purple-500/10 border border-purple-500/30 rounded-lg text-center">
            <div className="text-2xl font-bold text-purple-400">43</div>
            <div className="text-xs text-gray-400 mt-1">ردود مستلمة</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WhatsAppActionsModal;